import { FC } from 'react';
import { IMultiLanguageInputProps } from '../../types';
import { LOCALES } from 'src/constants/main';
import Text, { TEXT } from 'src/view/components/Text/Text';

type TProps = Pick<IMultiLanguageInputProps, 'validation'>;
interface IProps extends TProps {
  isValid: boolean;
  currentLanguage: LOCALES;
}

const MultiLanguageInputErrorText: FC<IProps> = ({ isValid, currentLanguage, validation }: IProps): JSX.Element | null => {
  const { enErrorText, arErrorText } = validation || {};

  const errorText = (): string | undefined => {
    if (isValid) return undefined;
    return currentLanguage === LOCALES.AR ? arErrorText || enErrorText : enErrorText || arErrorText;
  };

  if (!errorText()) return null;

  return <Text type={TEXT.ERROR} text={errorText()} className={validation?.errorBlockClassName} />;
};

export default MultiLanguageInputErrorText;
